import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { login } from '../services/adminService';

const AdminLogin = () => {
    const navigate = useNavigate();
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setIsLoading(true);

        try {
            await login(password);
            navigate('/admin');
        } catch (err) {
            setError(err.message || 'Invalid password');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="bg-dark-bg min-h-screen flex items-center justify-center px-6">
            <div className="max-w-md w-full">
                {/* Logo/Title */}
                <div className="text-center mb-10">
                    <h1 className="text-white text-4xl font-bold mb-2">Projekto Admin</h1>
                    <p className="text-gray-400 text-sm">Enter password to access dashboard</p>
                </div>

                {/* Login Form */}
                <div className="bg-dark-card border border-border-gray rounded-2xl p-8">
                    <form onSubmit={handleSubmit} className="space-y-6">
                        {/* Password Input */}
                        <div className="flex flex-col gap-3">
                            <label className="text-white text-sm font-bold uppercase tracking-wider">
                                Admin Password
                            </label>
                            <input
                                type="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                className="w-full rounded-xl border border-border-gray bg-dark-bg h-14 px-5 text-white text-base transition-all focus:outline-none focus:border-white placeholder:text-gray-700"
                                placeholder="Enter admin password"
                                required
                                autoFocus
                            />
                        </div>

                        {/* Error Message */}
                        {error && (
                            <div className="bg-red-500/10 border border-red-500/30 rounded-xl p-4 flex items-start gap-3">
                                <span className="material-symbols-outlined text-red-400 text-xl mt-0.5">error</span>
                                <p className="text-red-400 text-sm">{error}</p>
                            </div>
                        )}

                        {/* Submit Button */}
                        <button
                            type="submit"
                            disabled={isLoading || !password}
                            className="w-full bg-white hover:bg-gray-200 text-black h-14 rounded-xl text-base font-bold tracking-tight transition-all active:scale-[0.99] flex items-center justify-center gap-3 disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                            {isLoading ? (
                                <>
                                    <span className="material-symbols-outlined animate-spin">progress_activity</span>
                                    Logging in...
                                </>
                            ) : (
                                <>
                                    <span className="material-symbols-outlined">lock_open</span>
                                    Access Dashboard
                                </>
                            )}
                        </button>
                    </form>
                </div>

                {/* Back to Site */}
                <div className="mt-6 text-center">
                    <button
                        onClick={() => navigate('/')}
                        className="text-gray-400 hover:text-white text-sm transition-colors"
                    >
                        ← Back to Projekto
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AdminLogin;
